import { setSessionStorageItem } from '../../sessionStorage/utils';
import { SESSION_STORAGE_LAST_HELD_RESERVATION } from '../../../utils/constants';

export default (heldReservationVar) => {
  return (newHeldReservation) => {
    heldReservationVar(newHeldReservation);
    setSessionStorageItem(SESSION_STORAGE_LAST_HELD_RESERVATION, newHeldReservation);
  };
};
